import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';

const AdminRoute = () => {
  const { isAuthenticated, user, isLoading } = useAuthStore();

  // Afficher un loader pendant la vérification de l'authentification
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  // Rediriger vers la page de connexion si non authentifié
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Rediriger vers l'accueil si l'utilisateur n'est pas admin
  if (user?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  // Afficher le contenu admin si l'utilisateur est admin
  return <Outlet />;
};

export default AdminRoute; 